import React from 'react';
import * as Yup from 'yup';
import { Box, Button, Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { useFormik } from 'formik';
import AddIcon from '@mui/icons-material/Add';
import { SmallFormTextField } from '../../../../components/small-fields/SmallFormTextField';
import { DebounceInput } from 'react-debounce-input';
import { useAccomodationDiagram } from '../AccomodationDiagramContext';
import toast from 'react-hot-toast';
import { calculateAge } from '../../../../services/functions';

const ages = [
  { value: 'brak', label: 'Brak' }, { value: 3, label: '3' }, { value: 4, label: '4' },
  { value: 5, label: '5' }, { value: 6, label: '6' }, { value: 7, label: '7' },
  { value: 8, label: '8' }, { value: 9, label: '9' }, { value: 10, label: '10' },
  { value: 11, label: '11' }, { value: 12, label: '12' }, { value: 13, label: '13' },
  { value: 14, label: '14' }, { value: 15, label: '15' }, { value: 16, label: '16' },
  { value: 17, label: '17' }, { value: 18, label: '18' }, { value: 19, label: '19' }
];


export const EditHouseDialog = props => {
  const { open, setOpen, node } = props;
  const { updateNodeF, nodes, selectedAccomodationDiagram } = useAccomodationDiagram();
  const validationSchema = Yup.object({
    label: Yup.string().required('To pole nie może być puste')
      .min(1),
    preferredGender: Yup.string().required('To pole nie może być puste')
  });

  const initialValues = {
    label: node.data.label,
    preferredGender: node.data.preferredGender,
    preferredAge: node.data.preferredAge

  };


  const handleSubmit = values => {
    const houseAccommodatedBeds = nodes.filter(n => n.data.houseId == node.id && n.type == 'BedNode' && n.data.order);
    // Sprawdź, czy istnieją łóżka z inną preferowaną płcią
    const hasGenderConflict = values.preferredGender !== 'brak' && houseAccommodatedBeds.some(
      n => n.data.order.participant_gender !== values.preferredGender
    );

    if (hasGenderConflict) {
      toast.error(
        'Nie można zmienić preferowanej płci. W tym domku istnieją już zamówienia z inną płcią'
      );

      return;
    }
    // Sprawdź, czy istnieją łóżka z innym preferowanym wiekiem
    const hasAgeConflict = values.preferredAge !== 'brak' && houseAccommodatedBeds.some(
      n => calculateAge(n.data.order.participant_birth_date, true, selectedAccomodationDiagram.camp_date_from) !== values.preferredAge
    );
    if (hasAgeConflict) {
      toast.error(
        'Nie można zmienić preferowanego wieku. W tym domku istnieją już zamówienia z innym wiekiem'
      );

      return;
    }

    const newNode = node;
    newNode.data = {
      ...newNode.data,
      label: values.label,
      preferredAge: values.preferredAge,
      preferredGender: values.preferredGender
    };
    updateNodeF(node);
    setOpen(false);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema,
    onSubmit: values => {
      handleSubmit(values);
    }
  });

  const genders = [{ value: 'brak', label: 'Brak' }, { value: 'boy', label: 'Chłopcy' }, { value: 'girl', label: 'Dziewczynki' }];

  return (
    <Dialog
      sx={{ zIndex: 3333 }}
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="add-new-house-dialog"
      fullWidth
    >
      <DialogTitle id="add-new-house-dialog">Edytuj dane domu</DialogTitle>
      <DialogContent>
        <form onSubmit={formik.handleSubmit} style={{ textAlign: 'center' }}>
          <Box display="flex" flexDirection="column" mt={1} p={1} ml="5%" mr="5%">
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
              <Typography variant="subtitle2" flex="1 1 20%">Nazwa domu</Typography>
              <DebounceInput
                sx={{ flex: '1 1 80%' }}
                name="label"
                id="label"
                type="text"
                placeholder="nazwa domku"
                value={formik.values.label}
                onChange={formik.handleChange}
                error={formik.touched.label && Boolean(formik.errors.label)}
                helperText={formik.touched.label && formik.errors.label}
                debounceTimeout={100}
                element={SmallFormTextField}
                autoFocus
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
              <Typography variant="subtitle2" flex="1 1 20%">Preferowana płeć</Typography>
              <SmallFormTextField
                sx={{ flex: '1 1 80%' }}
                select
                id="preferredGender"
                name="preferredGender"
                options={genders}
                value={formik.values.preferredGender}
                onChange={formik.handleChange} />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="center" spacing={1} mb={2}>
              <Typography variant="subtitle2" flex="1 1 20%">Preferowany wiek</Typography>
              <SmallFormTextField
                sx={{ flex: '1 1 80%' }}
                select
                id="preferredAge"
                name="preferredAge"
                options={ages}
                value={formik.values.preferredAge}
                onChange={formik.handleChange} />
            </Stack>
          </Box>
          <Button
            color="primary"
            variant="contained"
            type="submit"
            sx={{ mt: 3 }}
            disabled={!formik.dirty}
          >
            <AddIcon />
          Zapisz
          </Button>
        </form>

      </DialogContent>
    </Dialog>
  );
};
